import React from "react";
import styled from "styled-components";
import { i18n } from "../../services";

export const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    margin: 20px 0 100px 0;
    justify-content: space-between;
`;
export const Header = styled.div`
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border-bottom: 1px solid #ccc;
    padding: 0 10px 5px 10px;
`;
export const Label = styled.div<{
    fontSize?: string;
    textAlign?: string;
}>`
    user-select: none;
    width: 100%;
    font-size: ${(p) => p.fontSize || "22px"};
    text-align: ${(p) => p.textAlign || "center"};
`;

const CONTENT_WIDTH = "50%";
export const Contents = styled.div`
    display: block;
    width: ${CONTENT_WIDTH};
    padding: 30px 3% 0 3%;
    min-height: 250px;

    & > div {
        outline: none;
    }

    & .focus {
        background-color: #eaeaea;
    }
`;

export const LTRContainer = styled.div`
    width: ${CONTENT_WIDTH};
`;
export const RTL = styled(Contents)`
    user-select: none;
    direction: rtl;
    text-align: right;
    line-height: 130%;
    color: #000;

    & > div {
        display: inline;
        line-height: 170%;
        font-size: 18px;
        white-space: pre-wrap;

        &:hover {
            background-color: #eaeaea;
        }
    }
`;

export const LTR = styled(Contents)<{ display: string }>`
    width: 100%;
    direction: ltr;
    text-align: left;
    white-space: pre-wrap;
    color: #000;
    background-color: #fffae3;
    display: ${(p) => p.display};
    line-height: 180%;
    font-size: 15px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial,
        sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";

    & div {
        line-height: 180%;
        font-size: 15px;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica,
            Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
            "Segoe UI Symbol";
    }
`;
export const LTRFragmented = styled(LTR)`
    background-color: #fff;
    & div {
        display: inline;
        white-space: pre-wrap;

        &:hover {
            background-color: #eaeaea;
        }
    }
`;

export const Divider = styled.div`
    position: absolute;
    left: 50%;
    top: 44px;
    width: 1px;
    height: calc(100% - 44px);
    background-color: #ccc;
`;

export function Titles({
    src_lang,
    dst_lang,
}: {
    src_lang: string;
    dst_lang: string;
}) {
    return (
        <Header>
            <Label>{i18n.get(`lang.${src_lang}`)}</Label>
            <Label>{i18n.get(`lang.${dst_lang}`)}</Label>
        </Header>
    );
}
